<template>
  <OrderPreview></OrderPreview>
</template>

<script>
import OrderPreview from '@/components/orders/OrderPreview';
export default {
    name: 'DemoWizard',
    components: {
      OrderPreview
    },
    methods: {
      start() {
          this.$store.commit('demoWizard/nextStep')
      }
    }
}
</script>

<style lang="scss">

</style>
